/**
 * Permet de remplacer Number.EPSILON qui n'est pas disponible sur IE11
 * (utiliser ici pour arrondir les 0.5 correctement)
 */
function getEpsilon() {
    var e = 1.0;
    while (1.0 + 0.5 * e !== 1.0) e *= 0.5;
    return e;
}

export { getEpsilon };
